import IframeDocumentRenderer from 'libs/iframe-document-renderer';
export default function(params) {
  const self = this;

  self.id = params['id'];
  self.type = 'Previewable';
  self.src = params['src'];
  self.config = {
    id: params['id'],
    route: Kadenze.Routes.course_gallery_coursework_coursework_field_entry_previewable_path(params['courseId'], params['courseworkId'], params['id']),
    $container: $(params['node']),
    style: { height: 800 },
    onLoad: function () {
      $(window).trigger('resize');
      self.config.$container.find('.js-previewable-loading').hide();
    }
  };

  self.init = () => {
    let renderer = new IframeDocumentRenderer(self.config);
    renderer.present();
  };

  self.init();

  return self;
}

